<template>
  <div>
  <vapp-header btnClose ></vapp-header>
<div class="container-guest p-5 d-flex flex-column align-items-center">


    <div class="text-info">
        <p class="text-gray forgot-password-sub-title">Please key in the 4-digit PIN that you have received in your email and your preferred new password.</p>
    </div>

  <img class="img-logo-forgot-password" src="@/assets/images/ic_forgot_password.svg">
    <form class="w-100 form-fnc" autocomplete="off">
      <div class="input-group " style="margin-bottom: 20px;">
          <img class="img-icon" src="@/assets/images/ic_4_digit_pin.svg">
          <input type="digit" class="form-control" placeholder="4-digit PIN" :maxlength="max" v-model="pin"
                 v-bind:class="{ 'is-invalid': attemptSubmit && (missingPin || invalidPinLength) }">
          <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'pin'">{{ error.text }}</div>
      </div>

      <div class="input-group">
          <img class="img-icon" src="@/assets/images/au-icon-password.svg">
          <input :type="passwordFieldType" class="form-control" placeholder="New Password" v-model="password"
            v-bind:class="{ 'is-invalid': attemptSubmit && (missingPassword || invalidPasswordLength) }">
          <button class="btn-iconright" @click="switchVisibility" v-if="password">
              <img class="img-iconright" src="@/assets/images/ic_eye_show.svg" v-if="passwordFieldType === 'text'"></img>
              <img class="img-iconright" src="@/assets/images/ic_eye_hide.svg" v-else></img>
          </button>
          <div class="invalid-feedback" v-for="error in errors" v-if="error.id == 'password'">{{ error.text }}</div>
      </div>


        <button @click="validateForm" class="btn btn-block btn-fnc">RESET PASSWORD</button>

        <flash-message transitionIn="animated swing"></flash-message>
    </form>

    <div class="plainText">  Don't have an account?
    <b-link :to="{ name: 'register' }" class="link-small" >
       <a class="one text-green" href="#" >Sign Up Free</a>
    </b-link>
  </div>

  <div class="plainText">    Remember Password?
    <b-link :to="{ name: 'login' }" class="link-small">
      <a class="one text-green" href="#" >Login</a>
    </b-link>
  </div>


</div>
</div>
</template>

<script>

    import cryptojs from 'crypto-js'

export default {
  data: function() {
    return {
      errors: [],
      email:null,
      password: null,
      pin: null,
      max: 4,
      attemptSubmit: false,
        passwordFieldType: 'password',
    };
  },
    computed: {

          missingPassword: function () {
                if (!this.password) { return true; } else { return false; }
            },
            invalidPasswordLength: function () {
                if (this.password.length<4) { return true; } else { return false; }
            },
            missingPin: function () {
              if (!this.pin) { return true;} else { return false; }
            },
            invalidPinLength: function () {
              return (this.isNumeric(this.pin) === false ||this.pin.length < 4 )
            },
            requestData: function() {
              return {

                email: this.$route.params.email,
                password: this.password,
                pin: this.pin,
            }
          }
    },
  methods: {
    resetPassword() {
      console.log("Email: ",this.$route.params.email)

          this.$root.$emit('show-loading', true);
          this.axios({
            method: 'put',
            url: '/password',
            data: this.requestData,
          }).then(response => {
            this.$root.$emit('show-loading', false);
            this.$swal({
              title: "Thank you",
              text: "Your password has been reset.",
              confirmButtonText: "OK",
              confirmButtonClass: "btn btn-block btn-fnc",
              confirmButtonColor:"#019689",
            }).then(() =>{
              // Redirect the user
              this.$router.push('/login')
            console.log('The Ok Button was clicked.');
    });


          }).catch(error => {
            this.$root.$emit('show-loading', false);
            this.$generalAPIErrorHandling(error, this.$router);
          })
      },
      validateForm: function (event) {
          this.errors = [];
          this.attemptSubmit = true;

          if (this.missingPassword && this.missingPin) {
              this.errors.push({id: 'password', text: "4-digit PIN and New Password cannot be empty."});
          }
          else {
              if (this.missingPassword) {
                  this.errors.push({id: 'password', text: "New Password cannot be empty."});
              }
              else if (this.invalidPasswordLength) {
                  this.errors.push({id: 'password', text: "Password has to be more than 4 characters"});
              }

              if (this.missingPin) {
                  this.errors.push({id: 'pin', text: "4-digit PIN cannot be empty."});
              }
              else if (this.invalidPinLength) {
                  this.errors.push({id: 'pin', text: "Pin has to be 4 digits"});
              }
          }

          if(!this.errors.length) {
            var formData = {
                "pin": this.pin,
                "password": this.password
            }
            this.resetPassword()
              event.preventDefault();
          } else {
              event.preventDefault();
          }
      },
      isNumeric: function (n) {
             return !isNaN(parseFloat(n)) && isFinite(n);
      },
      switchVisibility() {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        event.preventDefault();
      }
  },

};
</script>
